export const getLayerOpacity = (layer: any) => {
  if (!layer.opacity) {
    return 1;
  }

  return layer.opacity;
};
